<div *ngIf="data.expandedPreview" class="preview-toolbar">
  <span>{{ currentIndex + 1 }} / {{ data.imageUrls.length }}</span>
  <button type="button" aria-label="Đóng xem ảnh" (click)="close()">×</button>
</div>
<div class="overflow-hidden relative" [class.expanded-preview]="data.expandedPreview">
  <img
    [src]="currentImageUrl"
    class="object-contain max-w-[80vw] max-h-[80vh]"
    alt="Zoomed Image"
  />
  <button
    class="absolute top-1/2 left-2 -translate-y-1/2 rounded bg-gray-100 flex items-center justify-center w-[42px] h-[42px] disabled:opacity-50 outline-none"
    (click)="previousImage()"
    aria-label="Ảnh trước"
    [disabled]="currentIndex === 0"
  >
    <mat-icon>
      <img
        class="size-5"
        src="assets/icons/icn-chevron-left.svg"
        alt="icn-chervon-left"
      />
    </mat-icon>
  </button>
  <button
    class="absolute top-1/2 right-2 -translate-y-1/2 rounded bg-gray-100 flex items-center justify-center w-[42px] h-[42px] disabled:opacity-50 outline-none"
    (click)="nextImage()"
    aria-label="Ảnh tiếp theo"
    [disabled]="currentIndex === data.imageUrls.length - 1"
  >
    <mat-icon>
      <img
        class="size-5"
        src="assets/icons/icn-chevron-right.svg"
        alt="icn-chervon-right"
      />
    </mat-icon>
  </button>
</div>
